import { VueRegistration } from "@abaco/web-common/src/app";

const globals: VueRegistration = {
    DossierListTile: () => import("./components/tiles/list/DossierListTile.vue"),
    DossierTileContainer: () => import("./components/DossierTileContainer.vue"),
    DossierDetailTile: () => import("./components/tiles/detail/DossierDetailTile.vue"),
    DossierAddTile: () => import("./components/tiles/DossierAddTile.vue")
};

export default globals;
